import { lazy } from 'react'

// Interne Updates unter /internal/updates/:slug, nur fuer Aivy-Admins
// (Cognito-Gruppe __admin, siehe pages/internal-updates.js).
//
// Aufbau wie bei den Produkt-Updates (src/product-updates): jede Seite ist
// lazy geladen. Eine Seite ist ein Datenobjekt, das ./shared/page.js
// rendert, Optik und Bausteine kommen aus ../product-updates/shared.
//
// Die Sperre gilt nur in der Oberflaeche. Die Chunks sind wie jede andere
// Datei des Builds abrufbar, Zugangsdaten, Kundendaten und Zahlen, die nicht
// nach aussen duerfen, gehoeren also nicht auf diese Seiten.
//
// Erste Runde: Rückblick 22.09. bis 03.11.2026, ein Eintrag je Thema.
// Neuestes Update zuerst.
export const INTERNAL_UPDATES = [
  {
    slug: '2026-regelstand',
    date: '2026-11-03',
    title: 'Jede Stelle rechnet mit ihrem eigenen Regelstand',
    summary:
      'Regelstand 3 für neue Stellen, Tower of London und Interessen fairer bewertet, Kulturmodell-Fix und Feinschliff an den Challenges. Mit Hinweisen für Kundenfragen zu veränderten Scores.',
    Component: lazy(() => import('./2026-regelstand'))
  },
  {
    slug: '2026-einladen',
    date: '2026-11-03',
    title: 'Einladen geht schneller, Fristen bleiben stabil',
    summary:
      'Neues Einladen-Modal mit mehreren Talenten, Mail nachschicken, Vorlagen-Editor mit echter Testmail, Bearbeitungszeit je Stelle. Erinnerungen verlängern die Frist nicht mehr.',
    Component: lazy(() => import('./2026-einladen'))
  },
  {
    slug: '2026-sicherheit',
    date: '2026-11-03',
    title: 'Enger, sauberer, wirklich gelöscht',
    summary:
      'Rechte der Daten-API, Zugangsdaten aus dem Code, saubere Logs, Dokumente per signierter URL und DSGVO-Löschung inklusive Dokumenten.',
    Component: lazy(() => import('./2026-sicherheit'))
  },
  {
    slug: '2026-cdk',
    date: '2026-11-03',
    title: 'Raus aus Amplify Gen 1, Schritt für Schritt',
    summary:
      'Stand des Umzugs auf CDK je Umgebung, Pipeline, parallele API und Functions, umgeschaltete Hintergrundverarbeitung, Aufräumen und Fahrplan bis 2027.',
    Component: lazy(() => import('./2026-cdk'))
  },
  {
    slug: '2026-oberflaeche',
    date: '2026-11-02',
    title: 'Ruhiger, robuster, 29 Releases',
    summary:
      'Neue Sidebar, Tabellen und Einstellungen, Motion-Fundament, weniger stille Fehler, Discover und die Update-Seiten.',
    Component: lazy(() => import('./2026-oberflaeche'))
  },
  {
    slug: '2026-talente',
    date: '2026-10-30',
    title: 'Dokumente, Abmelden und ein ehrlicher Verlauf',
    summary:
      'Dokumente über S3, einzeln löschen und ersetzen, Abmelden statt Löschen in der App, Verlauf und klarere Aktionsnamen.',
    Component: lazy(() => import('./2026-talente'))
  },
  {
    slug: '2026-gemeinsame-pdf',
    date: '2026-10-29',
    title: 'Eine Datei pro Talent, im Dashboard und im ATS',
    summary:
      'Wie die gemeinsame PDF aus Profilen und Unterlagen entsteht, die Talentmappe im Dashboard und welches ATS die Datei wie bekommt. Über die generische API gibt es kein Bundle.',
    Component: lazy(() => import('./2026-gemeinsame-pdf'))
  },
  {
    slug: '2026-ats',
    date: '2026-10-29',
    title: 'ATS: sicherer, datensparsamer, besser getestet',
    summary:
      'Softgarden mit gemeinsamer PDF, /raw mit Kultur als Rangfolge, DELETE räumt auf, Smoke-Test und eine Übersicht, welches ATS was kann.',
    Component: lazy(() => import('./2026-ats'))
  },
  {
    slug: '2026-preismodell',
    date: '2026-10-28',
    title: 'Das neue Preismodell ist ausgerollt, aber noch dunkel',
    summary:
      'Pakete und Limits, die drei Modi pro Kunde, Sperren im Dashboard, Umstellung im OS und was CS und Sales dazu wissen sollten.',
    Component: lazy(() => import('./2026-preismodell'))
  },
  {
    slug: '2026-tools',
    date: '2026-10-22',
    title: 'Mehr Zahlen, ein besseres OS, viele Prototypen',
    summary:
      'Business Engine, Scorecard und Release-Monitoring im Analytics Hub, Neues im OS, HubSpot-Leadquelle, KI-Fehler-Triage und die Prototypen im Dashboard.',
    Component: lazy(() => import('./2026-tools'))
  },
  {
    slug: '2026-experimente',
    date: '2026-10-14',
    title: 'Rollouts und A/B-Tests ohne Deploy',
    summary:
      'Flags, Rollouts und A/B-Tests mit täglicher Auswertung und Auto-Stopp, bedient im OS. Warum die Schwelle bei 99 % liegt.',
    Component: lazy(() => import('./2026-experimente'))
  }
]

export { INTERNAL_HOME } from './home'

export const findInternalUpdate = (slug) =>
  INTERNAL_UPDATES.find((update) => update.slug === slug)
